module.exports = __webpack_public_path__ + "static/media/dashboard_light.6aeca02c.svg";